import { HttpClient } from '@angular/common/http';
//import { Component, OnInit, ViewChild } from '@angular/core';
//import { Component, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Component, ViewChild, ElementRef, OnDestroy, AfterViewInit, OnInit } from '@angular/core';
import { Observable, catchError, map, of, tap } from 'rxjs';
import { PartnersService } from '../../services/partners.service';
import { Partner } from '../../models/partner.model';
import { GoogleMap, MapInfoWindow, MapMarker } from '@angular/google-maps';


// --- Constantes Brasil --- 360 - Alle Palmeira
const BR_CENTER: google.maps.LatLngLiteral = { lat: -14.235004, lng: -51.92528 };
const BR_ZOOM = 4;
const BR_BOUNDS = { minLat: -34.0, maxLat: 5.5, minLng: -74.0, maxLng: -34.0 };
function isInBrazil(pos: google.maps.LatLngLiteral) {
  return (
    pos.lat >= BR_BOUNDS.minLat &&
    pos.lat <= BR_BOUNDS.maxLat &&
    pos.lng >= BR_BOUNDS.minLng &&
    pos.lng <= BR_BOUNDS.maxLng
  );
}


@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
})

export class MapComponent implements AfterViewInit, OnDestroy, OnInit  {
  infoContent!: Partner;
  @ViewChild(MapInfoWindow, { static: false }) info!: MapInfoWindow
  @ViewChild(GoogleMap, { static: false }) map!: GoogleMap
  @ViewChild(MapMarker, { static: false }) marker!: MapMarker

   ngOnInit(): void {
    // aqui você chama sua função de reload dos dados
    this.reloadData();
  }

  reloadData(): void {
    // Exemplo: buscar dados novamente (API ou serviço local)
    // this.partners = this.partnerService.getPartners();

    console.log('Dados recarregados ao carregar a página');
  }

  @ViewChild('mapHost', { static: false }) mapHost!: ElementRef<HTMLElement>;
  private ro?: ResizeObserver;

  partners!: Partner[];

  icon: google.maps.Icon = {
    url: "assets/icons/google_maps_pin.png", // url
    scaledSize: { height: 40, width: 40 } as google.maps.Size, // scaled size
  };


  markerOptions: google.maps.MarkerOptions = { draggable: false, icon: this.icon };
  apiLoaded: Observable<boolean>;
  openInfo(marker: any, content: any) {
    this.infoContent = content
    this.info.open(marker)
  }


  center: google.maps.LatLngLiteral = BR_CENTER;
  zoom = BR_ZOOM;
  display!: google.maps.LatLngLiteral;

  moveMap(event: google.maps.MapMouseEvent) {
    this.center = (event.latLng!.toJSON());
  }

  move(event: google.maps.MapMouseEvent) {
    this.display = event.latLng!.toJSON();
  }

  constructor(httpClient: HttpClient, public partnersService: PartnersService) {
    this.apiLoaded = httpClient.jsonp(
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyAV5ZxsqC1kusNs7lnpcfkgBq1ITp0wpto',
      'callback'
    ).pipe(
      map(() => true),
      tap(() => {
        this.partnersService.partner$.subscribe(res => this.partners = res);
      }),
      catchError(() => of(false)), 
    );

    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(res => {
        const guess = { lat: res.coords.latitude, lng: res.coords.longitude };
        if (isInBrazil(guess)) { // só centraliza se for Brasil
          this.center = guess;
          this.zoom = 6;
        } else {
          // mantém BR_CENTER/BR_ZOOM
        }
      }, () => {/* silent fail: mantém BR_CENTER */ });
    }
  }

  /** 1) Assim que o componente entra na tela, observe mudanças de tamanho do contêiner */
  ngAfterViewInit(): void {
    // se não tiver um host específico, você pode observar o .map-wrapper via querySelector também.
    const host = this.mapHost?.nativeElement || document.querySelector('.map-wrapper') as HTMLElement | null;
    if (host && 'ResizeObserver' in window) {
      this.ro = new ResizeObserver(() => this.forceRefresh());
      this.ro.observe(host);
    }

    // garante o primeiro cálculo de tiles após a renderização inicial
    setTimeout(() => this.forceRefresh());
  }

  ngOnDestroy(): void {
    this.ro?.disconnect();
  }

  onMapReady(_: google.maps.Map): void {
    //setTimeout(() => this.forceRefresh(), 0);
    setTimeout(() => this.forceRefresh(), 50);
  }


  /** 3) Dispara 'resize' e recentra sem mudar seu estado atual */
  private forceRefresh(): void {
    const gmap = this.map?.googleMap;
    if (!gmap) return;

    google.maps.event.trigger(gmap, 'resize');
    gmap.setCenter(this.center); // mantém o centro atual (evita “pulo”)
    // se quiser reafirmar o zoom:
    // gmap.setZoom(this.zoom);
  }

  zoomChanged() {
    const zoom = this.map.getZoom()!;
    this.icon.scaledSize = { height: zoom * 4, width: zoom * 4 } as google.maps.Size;
    this.markerOptions
    console.log(this.marker.cursorChanged)
    console.log(this.icon)
    this.marker.icon = this.icon;
  }



}
